// removed by extract-text-webpack-plugin
module.exports = {" _key":"ticker/PlayerInfo","playerhead":"_3Q2CPSHy","playergoals":"QsCjOPBJ","playerbox":"_37w5Xa0T","forwards":"spuc3_99","backwards":"_2I_mmuOu","playerno":"_1mL20lI4","playername":"_1ltw7GEa","player7m":"UCnEFjOz","playerpenalties":"_1jaeS-TH","playerwarn":"Td3PSAg-","player2m":"_6t_zBnl-","playerdisq":"_32jrMXai","debugcells":"_2Lu-dmj-"};


//////////////////
// WEBPACK FOOTER
// ./src/widgets/styles/PlayerInfo.m.css
// module id = ./src/widgets/styles/PlayerInfo.m.css
// module chunks = main